import { FC } from "react";

import {
  InputFormElement,
  PasswordFormElement,
  SelectFormElement,
  FormStep,
  NameIdentifiers,
} from "../../general";

type RenderStepProps = {
  step: FormStep;
  isPassword: boolean;
  setValue: (
    name: NameIdentifiers,
  ) => (value: string | boolean | number) => void;
  findStepByName: (name: NameIdentifiers) => FormStep | undefined;
};

export const RenderStep: FC<React.PropsWithChildren<RenderStepProps>> = ({
  step,
  isPassword,
  setValue,
  findStepByName,
}) => {
  const { value, type, name, showWith, mainTitle } = step;

  const currentStepValue = value || "";

  let showWithStep: FormStep | undefined;
  if (showWith) {
    showWithStep = findStepByName(showWith);
  }

  return (
    <>
      {mainTitle && (
        <h3 className="text-primary mb-6 text-2xl font-semibold">
          {mainTitle}
        </h3>
      )}
      {step && (
        <>
          {type === "password" && isPassword && (
            <PasswordFormElement
              password={currentStepValue.toString()}
              setValue={setValue(name)}
              currentStep={step}
            />
          )}

          {(type === "text" || type === "email" || type === "url") && (
            <InputFormElement
              value={currentStepValue}
              setValue={setValue(name)}
              currentStep={step}
            />
          )}

          {type === "select" && (
            <SelectFormElement
              value={currentStepValue.toString()}
              setValue={setValue(name)}
              currentStep={step}
            />
          )}
        </>
      )}

      {showWithStep && (
        <RenderStep
          step={showWithStep}
          isPassword={isPassword}
          setValue={setValue}
          findStepByName={findStepByName}
        />
      )}
    </>
  );
};
